<template>
    <div
        ref="root"
        v-if="isActive"
        class="newsticker"
        :data-valid-from="getValidFrom"
        :data-valid-until="getValidUntil"
        :data-title="encodeURIComponent(JSON.stringify(getTitle))"
        :data-text="encodeURIComponent(JSON.stringify(getText))"
    ></div>
</template>

<script>
import { mapGetters } from 'vuex';
import Newsticker from '@/external/assorted/Newsticker';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {
        ...mapGetters(['getProp']),
        isActive() {
            let data = this.getProp('deha.user.misc.newsticker');
            if (data === undefined) {
                return false;
            }
            if (
                !('text' in data) ||
                data.text === undefined ||
                data.text === null ||
                data.text === ''
            ) {
                return false;
            }
            let now = new Date();
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            now.setMilliseconds(0);

            let valid_from = null;
            if (
                'valid_from' in data &&
                data.valid_from !== undefined &&
                data.valid_from !== null &&
                data.valid_from !== ''
            ) {
                valid_from = new Date(data.valid_from);
                valid_from.setHours(0);
                valid_from.setMinutes(0);
                valid_from.setSeconds(0);
                valid_from.setMilliseconds(0);
            }

            let valid_until = null;
            if (
                'valid_until' in data &&
                data.valid_until !== undefined &&
                data.valid_until !== null &&
                data.valid_until !== ''
            ) {
                valid_until = new Date(data.valid_until);
                valid_until.setHours(0);
                valid_until.setMinutes(0);
                valid_until.setSeconds(0);
                valid_until.setMilliseconds(0);
            }

            return (
                (valid_from !== null || valid_until !== null) &&
                (valid_from === null || now >= valid_from) &&
                (valid_until === null || now <= valid_until)
            );
        },
        getValidFrom() {
            let valid_from = this.getProp('deha.user.misc.newsticker.valid_from');
            if (valid_from === undefined || valid_from === null || valid_from === '') {
                return false;
            }
            valid_from = new Date(valid_from);
            valid_from.setHours(0);
            valid_from.setMinutes(0);
            valid_from.setSeconds(0);
            valid_from.setMilliseconds(0);
            return (
                valid_from.getFullYear() +
                '-' +
                ('0' + (valid_from.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + valid_from.getDate()).slice(-2)
            );
        },
        getValidUntil() {
            let valid_until = this.getProp('deha.user.misc.newsticker.valid_until');
            if (valid_until === undefined || valid_until === null || valid_until === '') {
                return false;
            }
            valid_until = new Date(valid_until);
            valid_until.setHours(0);
            valid_until.setMinutes(0);
            valid_until.setSeconds(0);
            valid_until.setMilliseconds(0);
            return (
                valid_until.getFullYear() +
                '-' +
                ('0' + (valid_until.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + valid_until.getDate()).slice(-2)
            );
        },
        getTitle() {
            let title = this.getProp('deha.user.misc.newsticker.title');
            if (title === undefined || title === null || title === '') {
                return '';
            }
            return title;
        },
        getText() {
            let text = this.getProp('deha.user.misc.newsticker.text');
            if (text === undefined || text === null || text === '') {
                return '';
            }
            return text;
        }
    },
    created() {},
    mounted() {
        let i = new Newsticker();
        i.init(this.$refs.root);
    },
    updated() {
        let i = new Newsticker();
        i.init(this.$refs.root);
    },
    props: {}
};
</script>
